export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string | number; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
};

export enum AccessType {
  Authorised = 'AUTHORISED',
  IncorrectAdvertiser = 'INCORRECT_ADVERTISER',
  NotFound = 'NOT_FOUND',
  Unauthorised = 'UNAUTHORISED',
}

export type AdvertiserJobAccess = {
  __typename?: 'AdvertiserJobAccess';
  accessType: AccessType;
  correctAdvertiserId?: Maybe<Scalars['ID']['output']>;
  correctAdvertiserName?: Maybe<Scalars['String']['output']>;
};

export type Attachment = {
  __typename?: 'Attachment';
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isPdf: Scalars['Boolean']['output'];
  type: Scalars['Int']['output'];
  typeName: Scalars['String']['output'];
};

export type BaseCredential = {
  __typename?: 'BaseCredential';
  credentialInfo: Array<CredentialInfo>;
};

export enum BillableStatus {
  Billable = 'BILLABLE',
  NotBillable = 'NOT_BILLABLE',
}

export enum Bucket {
  Accept = 'ACCEPT',
  Inbox = 'INBOX',
  Interview = 'INTERVIEW',
  NotSuitable = 'NOT_SUITABLE',
  Offer = 'OFFER',
  Prescreen = 'PRESCREEN',
  Shortlist = 'SHORTLIST',
}

export type BucketCounts = {
  __typename?: 'BucketCounts';
  acceptCount: Scalars['Int']['output'];
  inboxCount: Scalars['Int']['output'];
  interviewCount: Scalars['Int']['output'];
  newCount: Scalars['Int']['output'];
  notSuitableCount: Scalars['Int']['output'];
  offerCount: Scalars['Int']['output'];
  prescreenCount: Scalars['Int']['output'];
  shortlistCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  viewedCount: Scalars['Int']['output'];
};

export type Cm_Location = {
  __typename?: 'CM_Location';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type Cm_LocationDescriptionArgs = {
  input: Cm_LocationDescriptionInput;
};

export type Cm_LocationDescriptionInput = {
  displayCountry: Scalars['String']['input'];
  language: Scalars['String']['input'];
};

export type Candidate = {
  __typename?: 'Candidate';
  prospects: Array<Prospect>;
};

export type CandidateDetails = {
  __typename?: 'CandidateDetails';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isNewToWorkforce?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mostRecentCompanyName?: Maybe<Scalars['String']['output']>;
  mostRecentJobTitle?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  previousCoverLetter?: Maybe<PreviousAttachment>;
  previousResume?: Maybe<PreviousAttachment>;
  timeInRoleMonths?: Maybe<Scalars['Int']['output']>;
  timeInRoleYears?: Maybe<Scalars['Int']['output']>;
};

export type CandidateId = {
  candidateId: Scalars['ID']['input'];
  prospectId: Scalars['ID']['input'];
};

export type CandidatePayload = {
  __typename?: 'CandidatePayload';
  node: Candidate;
};

export type CandidatePreviousApps = {
  __typename?: 'CandidatePreviousApps';
  candidateDetails?: Maybe<CandidateDetails>;
  mostRecentApplication?: Maybe<MostRecentApplication>;
};

export type CredentialInfo = {
  __typename?: 'CredentialInfo';
  name: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type Education = {
  __typename?: 'Education';
  completed: Scalars['Boolean']['output'];
  completionDate?: Maybe<EducationCompletionDate>;
  credential?: Maybe<BaseCredential>;
  highlights?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  institute: ProfileTextObject;
  name: ProfileTextObject;
};

export type EducationCompletionDate = {
  __typename?: 'EducationCompletionDate';
  month?: Maybe<Scalars['Int']['output']>;
  year: Scalars['Int']['output'];
};

export type Error = {
  message: Scalars['String']['output'];
};

export type ExpectedSalary = {
  __typename?: 'ExpectedSalary';
  currency?: Maybe<Scalars['String']['output']>;
  maximumSalaryValue?: Maybe<Scalars['Float']['output']>;
  minimumSalaryValue?: Maybe<Scalars['Float']['output']>;
  salaryType?: Maybe<SalaryType>;
};

export type FilterCounts = {
  __typename?: 'FilterCounts';
  rrFilterCounts?: Maybe<Array<Maybe<RoleRequirementFilterCount>>>;
};

export enum FilterOperator {
  And = 'AND',
  Or = 'OR',
}

export type JobApplicationStatus = {
  __typename?: 'JobApplicationStatus';
  status?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type JobApplicationSummariesInput = {
  /** seek web advertiser id */
  advertiserId: Scalars['ID']['input'];
  bucket?: InputMaybe<Bucket>;
  filters?: InputMaybe<ProspectFilters>;
  positionId: Scalars['ID']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type JobApplicationSummariesPayload = {
  __typename?: 'JobApplicationSummariesPayload';
  nodes: Array<Maybe<JobApplicationSummary>>;
};

export type JobApplicationSummary = {
  __typename?: 'JobApplicationSummary';
  adcentreProspectId: Scalars['ID']['output'];
  applicationCorrelationId: Scalars['ID']['output'];
  candidateFirstname: Scalars['String']['output'];
  candidateLastname: Scalars['String']['output'];
  status: JobApplicationStatus;
};

export type Licence = {
  __typename?: 'Licence';
  credential?: Maybe<BaseCredential>;
  description?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<MonthYear>;
  formattedExpiryDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  issueDate?: Maybe<MonthYear>;
  issuingOrganisation?: Maybe<Scalars['String']['output']>;
  name: ProfileTextObject;
  noExpiryDate: Scalars['Boolean']['output'];
  origin: Scalars['String']['output'];
};

export type MatchedQualities = {
  __typename?: 'MatchedQualities';
  hasError: Scalars['Boolean']['output'];
  qualities?: Maybe<Array<MatchedQuality>>;
};

export type MatchedQuality = {
  __typename?: 'MatchedQuality';
  displayLabel: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isTop: Scalars['Boolean']['output'];
  relevanceScore: Scalars['Float']['output'];
};

export type MonthYear = {
  __typename?: 'MonthYear';
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type MostRecentApplication = {
  __typename?: 'MostRecentApplication';
  alreadyAppliedForThisPosition: Scalars['Boolean']['output'];
  dateApplied: Scalars['String']['output'];
  jobTitle: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type Nationality = {
  __typename?: 'Nationality';
  countryName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type NationalityCountryNameArgs = {
  input: NationalityLabelInput;
};

export type NationalityInput = {
  jobId: Scalars['Int']['input'];
};

export type NationalityLabelInput = {
  language: Scalars['String']['input'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  preFilterTotal: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PositionSummary = {
  __typename?: 'PositionSummary';
  hasAccess: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type PreviousAttachment = {
  __typename?: 'PreviousAttachment';
  attachmentId: Scalars['ID']['output'];
  fileName: Scalars['String']['output'];
  prospectId: Scalars['ID']['output'];
};

export type Profile = {
  __typename?: 'Profile';
  education: Array<Education>;
  expectedSalaries: Array<ExpectedSalary>;
  homeLocation?: Maybe<Cm_Location>;
  licences: Array<Licence>;
  nationality: ProfileNationalityResponse;
  rightsToWork: Array<RightToWork>;
  rightsToWorkV2: Array<RightToWorkV2>;
  skills: Array<Skill>;
  verifiedIdentity?: Maybe<VerifiedIdentity>;
  workHistory: Array<WorkHistory>;
};

export type ProfileNationalityArgs = {
  input: NationalityInput;
};

export type ProfileNationalityResponse =
  | ProfileNationalityResponseSuccess
  | ResponseError;

export type ProfileNationalityResponseSuccess = {
  __typename?: 'ProfileNationalityResponseSuccess';
  result: Array<Nationality>;
};

export type ProfileTextObject = {
  __typename?: 'ProfileTextObject';
  text: Scalars['String']['output'];
};

export type Prospect = {
  __typename?: 'Prospect';
  /**
   * Application Correlation ID
   * returned from searchApi and null when fetching from adcentre
   */
  applicationCorrelationId?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the prospect applied */
  appliedDate?: Maybe<Scalars['DateTime']['output']>;
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  /** Billable status denotes whether the prospect is billable or not. If null, the prospect does not belong to a Pay Per Application job. */
  billableStatus?: Maybe<BillableStatus>;
  bucket?: Maybe<Bucket>;
  /**
   * Adcentre Candidate ID
   * Note: this is different to seekCandidateId
   */
  candidateId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emailCount?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Adcentre Prospect ID */
  id: Scalars['ID']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  /** Job Application ID from the job apply pipeline */
  jobApplicationId?: Maybe<Scalars['String']['output']>;
  /** Adcentre Listing SEEK ID */
  jobId: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  /** CQ Matched qualities */
  matchedQualities: MatchedQualities;
  mostRecentCompanyName?: Maybe<Scalars['String']['output']>;
  mostRecentJobTitle?: Maybe<Scalars['String']['output']>;
  /** Tenure in months for the most recent role at time of application */
  mostRecentRoleMonths?: Maybe<Scalars['Int']['output']>;
  noteCount?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  /** Position summary (id, title, hasAccess) */
  positionSummary?: Maybe<PositionSummary>;
  /** Profile */
  profile?: Maybe<Profile>;
  prospectCount?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<ProspectRating>;
  /** Candidate ID in the Seek web db */
  seekCandidateId?: Maybe<Scalars['String']['output']>;
  /** ID 1: Seek imported from SAE, 3: Uploaded manually by advertiser */
  source?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  /** Returns a submission with role requirements or an error if an error occurred while fetching role requirements. */
  submission?: Maybe<SubmissionResult>;
  /** Certsy verifications */
  verifications: Array<Verification>;
};

export type ProspectByAdcentreProspectIdInput = {
  adcentreProspectId: Scalars['ID']['input'];
  advertiserId: Scalars['ID']['input'];
  positionId: Scalars['ID']['input'];
};

export type ProspectFilters = {
  homeLocationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  nationalityRightToWorkIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  rrGlobalFilters?: InputMaybe<Array<RoleRequirementFilterInput>>;
};

export type ProspectRating = {
  __typename?: 'ProspectRating';
  lastRatedDate?: Maybe<Scalars['DateTime']['output']>;
  ratedByName?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
};

export type ProspectsWithPaginationByJobIdInput = {
  /** seek web advertiser id */
  advertiserId: Scalars['ID']['input'];
  bucket?: InputMaybe<Bucket>;
  filters?: InputMaybe<ProspectFilters>;
  jobId: Scalars['ID']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type ProspectsWithPaginationPayload = {
  __typename?: 'ProspectsWithPaginationPayload';
  bucketCounts?: Maybe<BucketCounts>;
  filterCounts?: Maybe<FilterCounts>;
  nodes: Array<Maybe<Prospect>>;
  pageInfo: PageInfo;
};

export type Query = {
  __typename?: 'Query';
  _?: Maybe<Scalars['Boolean']['output']>;
  /** access to the position with seek advertiser id and job id */
  advertiserJobAccessByJobId: AdvertiserJobAccess;
  /** access to the position with advertiser id */
  advertiserJobAccessByPositionId: AdvertiserJobAccess;
  candidateById: CandidatePayload;
  candidatePreviousAppsByEmail: CandidatePreviousApps;
  jobApplicationSummariesByPositionId: JobApplicationSummariesPayload;
  prospectByAdcentreProspectId?: Maybe<Prospect>;
  prospectsWithPaginationByJobId: ProspectsWithPaginationPayload;
  version?: Maybe<Scalars['String']['output']>;
};

export type QueryAdvertiserJobAccessByJobIdArgs = {
  advertiserId: Scalars['ID']['input'];
  jobId: Scalars['ID']['input'];
};

export type QueryAdvertiserJobAccessByPositionIdArgs = {
  advertiserId: Scalars['ID']['input'];
  positionId: Scalars['ID']['input'];
};

export type QueryCandidateByIdArgs = {
  id: CandidateId;
};

export type QueryCandidatePreviousAppsByEmailArgs = {
  email: Scalars['String']['input'];
  positionId: Scalars['ID']['input'];
};

export type QueryJobApplicationSummariesByPositionIdArgs = {
  input: JobApplicationSummariesInput;
};

export type QueryProspectByAdcentreProspectIdArgs = {
  input: ProspectByAdcentreProspectIdInput;
};

export type QueryProspectsWithPaginationByJobIdArgs = {
  input: ProspectsWithPaginationByJobIdInput;
};

export type ResponseError = {
  __typename?: 'ResponseError';
  error: ResponseErrorReason;
};

export enum ResponseErrorReason {
  BadInput = 'BAD_INPUT',
  Forbidden = 'FORBIDDEN',
  NotFound = 'NOT_FOUND',
  UnexpectedError = 'UNEXPECTED_ERROR',
}

export type RightToWork = {
  __typename?: 'RightToWork';
  answer: Scalars['String']['output'];
  country: Scalars['String']['output'];
};

export type RightToWorkDisplayLabelInput = {
  language: Scalars['String']['input'];
};

export type RightToWorkV2 = {
  __typename?: 'RightToWorkV2';
  displayLabel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type RightToWorkV2DisplayLabelArgs = {
  input: RightToWorkDisplayLabelInput;
};

export type RoleRequirement = {
  __typename?: 'RoleRequirement';
  answerType?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use rrAnswers instead */
  answers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  globalId?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  questionId?: Maybe<Scalars['String']['output']>;
  rrAnswers: Array<RoleRequirementAnswer>;
  score?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<RoleRequirementStatus>;
  verifications: Array<Verification>;
};

export type RoleRequirementAnswer = {
  __typename?: 'RoleRequirementAnswer';
  globalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isVerified: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
};

export type RoleRequirementFilterCount = {
  __typename?: 'RoleRequirementFilterCount';
  count: Scalars['Int']['output'];
  id: Scalars['String']['output'];
};

export type RoleRequirementFilterInput = {
  answerIds: Array<InputMaybe<Scalars['String']['input']>>;
  operator: FilterOperator;
  questionId: Scalars['String']['input'];
};

/**
 * Possible statuses for role requirement questions.
 * Calculated based on role requirement score and whether the role requirement answer is verified by Certsy
 */
export enum RoleRequirementStatus {
  /** Certified by certsy */
  Certified = 'CERTIFIED',
  /** Custom role requirement question */
  Custom = 'CUSTOM',
  /** Answer matches the desired answer of the role requirement question */
  Match = 'MATCH',
  /** Other statuses */
  Neutral = 'NEUTRAL',
  /** Answer does not match the desired answer of the role requirement question */
  NoMatch = 'NO_MATCH',
}

export enum SalaryType {
  Annually = 'ANNUALLY',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY',
}

export type Skill = {
  __typename?: 'Skill';
  keyword: ProfileTextObject;
};

export enum Sort {
  ApplicationDate = 'APPLICATION_DATE',
  Name = 'NAME',
  Rating = 'RATING',
  Relevance = 'RELEVANCE',
  Score = 'SCORE',
  SearchRelevance = 'SEARCH_RELEVANCE',
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type Submission = {
  __typename?: 'Submission';
  roleRequirements?: Maybe<Array<RoleRequirement>>;
};

export type SubmissionError = Error & {
  __typename?: 'SubmissionError';
  message: Scalars['String']['output'];
};

export type SubmissionResult = Submission | SubmissionError;

export type Verification = {
  __typename?: 'Verification';
  credentialInfo: Array<CredentialInfo>;
  title: Scalars['String']['output'];
};

export type VerifiedIdentity = {
  __typename?: 'VerifiedIdentity';
  fullName: Scalars['String']['output'];
};

export type WorkHistory = {
  __typename?: 'WorkHistory';
  achievements?: Maybe<Scalars['String']['output']>;
  company: ProfileTextObject;
  endDate?: Maybe<MonthYear>;
  id: Scalars['String']['output'];
  startDate: MonthYear;
  title: ProfileTextObject;
};
